import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<nb-side-nav-section>` — an uppercase group label inside the sidebar
 * (Mockup `web.css .navsec`). Project the label text as content. Inside a
 * `.sidebar.admin` column it fades to the dark-variant muted colour.
 *
 * @example <nb-side-nav-section>Oversikt</nb-side-nav-section>
 */
@Component({
  selector: 'nb-side-nav-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'navsec', role: 'presentation' },
  template: `<ng-content />`,
  styleUrl: './side-nav-section.css',
})
export class NbSideNavSection {}
